import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './components/Footer';

/**
 * Catch-all for unknown URLs.
 *
 * Needed because the hosts serve index.html for anything that is not a real
 * file -- .htaccess on Afrihost, a CloudFront 404 mapping on the dev site --
 * so React Router sees every bad URL. Without a route matching "*", <Routes>
 * renders nothing and the visitor gets a navbar above an empty page.
 */
const NotFound: React.FC = () => (
    <div className="font-sans text-gray-800">

        <section id="banner" className="hero-banner">
            <img src="/media/hero-banner.jpg" alt="Kilo Delta On Call" className="hero-banner-image" />
            <div className="hero-content">
                <img alt="Kilo Delta Logo" src="/media/logo-full.png" className="logo-hero-banner" />
                <h1>PAGE NOT FOUND</h1>
                <h2>LET&rsquo;S GET YOU BACK</h2>
            </div>
        </section>

        <section className="legal-section">
            <div className="legal-content notfound-content">
                <p>
                    We could not find that page. It may have moved, or the link may be wrong.
                </p>
                <p className="notfound-actions">
                    <Link to="/" className="donate-button notfound-home">Back to home</Link>
                </p>
                <p>
                    If you were trying to reach something specific,{' '}
                    <a href="mailto:info@kilodeltaoncall.org">email us</a> and we will point you
                    the right way.
                </p>
                <p>
                    <strong>In an emergency, call 10177 (ambulance and fire), 10111 (police),
                    or 112 from a mobile phone.</strong>
                </p>
            </div>
        </section>

        <Footer />
    </div>
);

export default NotFound;
